import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import login from '../../api/login';
import icone from '../../assets/logo.png';
import FormLogin from './formLogin/formLogin';
import Apresentacao from './apresentacao/apresentacao';
import CondominioSelector from '../../components/CondominioSelector/CondominioSelector';
import { buildSystemRedirectUrl, redirectToSystem } from '../../utils/systemRedirect';

const Login = () => {
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showCondominioSelector, setShowCondominioSelector] = useState(false);
  const [condominios, setCondominios] = useState([]);
  const [token, setToken] = useState('');
  const [userDetails, setUserDetails] = useState(null);
  const navigate = useNavigate();

  const handleChangeUser = (event) => {
    setUser(event.target.value.toLowerCase());
  };

  const handleChangePassword = (event) => {
    setPassword(event.target.value);
  };

const createSessionAndRedirect = (token, condominio) => {
  try {
    sessionStorage.setItem('token', token);

    const finalUrl = buildSystemRedirectUrl(condominio.app_url, {
      token,
      condominioID: String(condominio.id),
    });

    console.log('Redirect URL:', finalUrl);
    redirectToSystem(finalUrl);
  } catch (e) {
    console.error(e);
    setErrorMessage(e.message || 'Erro ao montar URL de redirecionamento.');
  }
};


  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');

    try {
      const data = await login(user, password);

      if (!data?.token || !data?.user) {
        setErrorMessage('Resposta inesperada do servidor.');
        return;
      }

      // ✅ Usa o novo campo condominios
      const condominios = data.condominios || [];

      if (condominios.length === 0) {
        setErrorMessage('Nenhum condomínio disponível para este usuário.');
        return;
      }

      // ✅ Se tiver apenas 1 condomínio, redireciona direto
      if (condominios.length === 1) {
        const condominio = condominios[0];
        
        if (!condominio.app_url) {
          setErrorMessage('URL do sistema não encontrada.');
          return;
        }

        createSessionAndRedirect(data.token, condominio);
        return;
      }

      // ✅ Se tiver múltiplos, mostra o seletor
      setToken(data.token);
      setUserDetails(data.user);
      setCondominios(condominios);
      setShowCondominioSelector(true);

    } catch (err) {
      setErrorMessage(err.message || 'Erro ao conectar ao servidor.');
    }
  };

  const handleCondominioSelect = (condominioSelecionado) => {
    if (!condominioSelecionado.app_url) {
      setErrorMessage('URL do sistema não encontrada.');
      setShowCondominioSelector(false);
      return;
    }

    createSessionAndRedirect(token, condominioSelecionado);

  };

  const handleCondominioCancel = () => {
    setShowCondominioSelector(false);
    setCondominios([]);
    setToken('');
    setUserDetails(null);
  };

  return (
    <>
      <div className='flex h-screen w-screen overflow-auto'>
        <div className='w-full lg:w-1/4'>
          <FormLogin
            icone={icone}
            user={user}
            password={password}
            errorMessage={errorMessage}
            onChangeUser={handleChangeUser}
            onChangePassword={handleChangePassword}
            onSubmit={handleSubmit}
            onClickRegister={() => navigate('/registro')}
            onClickForgotPassword={() => navigate('/redefinir')}
          />
        </div>
        <div className='hidden lg:block lg:w-3/4'>
          <Apresentacao />
        </div>
      </div>

      {showCondominioSelector && (
        <CondominioSelector
          condominios={condominios}
          onSelect={handleCondominioSelect}
          onCancel={handleCondominioCancel}
        />
      )}
    </>
  );
};

export default Login;
